import { z } from 'zod';
import { UserDataForClientSchema } from '../../entities';

export const CurrentUserDataResponseSchema = z.object({
    userData: UserDataForClientSchema,
});

export const UpdateOnboardingResponseSchema = z.object({
    userData: UserDataForClientSchema,
});

export const SignedUploadUrlResultSchema = z.object({
    signedUrl: z.string().url(),
    fileName: z.string(),
    publicUrl: z.string().url(),
    requestMethod: z.enum(['PUT', 'POST']),
    headers: z.record(z.string()),
});

export const GetUsersPageResponseSchema = z.object({
    items: z.array(UserDataForClientSchema),
    totalItems: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    nextToken: z.string().nullable().optional(),
});
